import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  loginUser,
  setUserFromLocalStorage,
  sendOtp,
  validate2FAToken,
  generateSecret2FA,
  verify2FAToken,
  send2FAOtp,
  verify2FAOtp,
} from '../../actions/authActions';
import { Col, Row, Form, Button, Alert } from "react-bootstrap";
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
var QRCode = require("qrcode.react");

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      is_2FA_enabled: false,
      isValidUser: false,
      token: "",
      error: ''
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem("admin-panel-sessionToken") &&
      localStorage.getItem("admin-panel-sessionToken") !== null
    ) {
      this.props.history.push("/dashboard");
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.auth.sessionToken && nextProps.auth.sessionToken !== null) {
      this.props.history.push("/dashboard");
    }
    if (
      localStorage.getItem("admin-panel-sessionToken") &&
      localStorage.getItem("admin-panel-sessionToken") !== null
    ) {
      this.props.history.push("/dashboard");
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleLogin = (e) => {
    e.preventDefault();
    
    this.props
      .loginUser(this.state.email, this.state.password)
      .then((res) => {
        const { user } = res;
        if (Object.keys(user) && !user.is_2FA_enabled)
          this.props.generateSecret2FA(this.state.email);
      })
      .catch((err) => {
        console.log(err);
        this.setState({error: err });
        // console.log('rwewe',err);
      });
  };

  handleQRTokenValidate = (e) => {
    e.preventDefault();
    const { user } = this.props;
    if (user) {
      const { is_2FA_enabled, email } = user;
      if (!is_2FA_enabled && email) {
        this.props
          .verify2FAToken(email, this.state.token)
          .then(() => {
            this.props.history.push("/dashboard/");
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (is_2FA_enabled && email) {
        this.props
          .validate2FAToken(email, this.state.token)
          .then(() => {
            this.props.history.push("/dashboard/");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  handle2FASendOtp = (e) => {
    e.preventDefault();
    let email = "";
    if (this.props.auth && this.props.auth.user) {
      email = this.props.auth.user.email;
      this.props
        .send2FAOtp(email)
        .then((res) => {
          this.props.history.push("/2fa-send-otp");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  render() {
    const { is_2FA_enabled, _id: isValidUser, secret } = this.props.user;
    return (
      <div>
        <Row>
          <Col sm={4}></Col>
          <Col sm={4} style={{ "padding-top": "20%" }}>
            <form onSubmit={this.onSubmit}>
              {!isValidUser && (
                <div>
                  <h3>Login</h3>
                  <Row>
                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        onChange={this.onChange}
                        value={this.state.email}
                        id="email"
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group>
                      <Form.Label>password</Form.Label>
                      <Form.Control
                        type="password"
                        onChange={this.onChange}
                        value={this.state.password}
                        id="password"
                      />
                    </Form.Group>
                  </Row>
                  <Button type="submit" onClick={this.handleLogin}>
                    Login
                  </Button>
                </div>
              )}
              {secret && (
                <>
                  <Form.Label>
                    Scan QR Code Using Google Authenticator App
                  </Form.Label>
                  <div>{secret && <QRCode value={secret} />}</div>
                </>
              )}
              {isValidUser && (
                <>
                  <Form.Group>
                    <Form.Control
                      type="password"
                      onChange={this.onChange}
                      value={this.state.token}
                      id="token"
                      placeholder="Enter Google Auth Token"
                    />
                  </Form.Group>
                  <Form.Group>
                    <Button type="submit" onClick={this.handleQRTokenValidate}>
                      Submit
                    </Button>
                  </Form.Group>
                  <Form.Group>
                    {is_2FA_enabled && (
                      <Link to="/2fa-send-otp" onClick={this.handle2FASendOtp}>
                        Can't access your device, Reset here{" "}
                      </Link>
                    )}
                  </Form.Group>
                </>
              )}
            </form>
            <p style={{color:'red'}}>
            {this.props.error || this.state.error}
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm={4}></Col>
          <Col sm={4} style={{ 'padding-top': '1em' }}>
            <Link to={'/verify-otp'}>Reset Password</Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    error: state.auth.error,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, {
  loginUser,
  setUserFromLocalStorage,
  sendOtp,
  verify2FAToken,
  validate2FAToken,
  generateSecret2FA,
  verify2FAOtp,
  send2FAOtp,
})(Login);
